export const API = process.env.REACT_APP_BACKEND
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'http://localhost:8000'
export const FAPI = process.env.REACT_APP_FRONTEND
export const S3_INTEGRATION_ENABLED = process.env.REACT_APP_S3_INTEGRATION_ENABLED
export const ENABLE_MONGO_READ_IMAGE = process.env.REACT_APP_ENABLE_MONGO_READ_IMAGE
export const ENABLE_IMAGE_CROPPING = process.env.REACT_APP_IMAGE_CROPPING_ENABLED
export const ENABLE_TEXTDROPDOWN_FILTER = process.env.REACT_APP_TEXTDROPDOWN_FILTER_ENABLED
export const BUG_REPORT_FORM = process.env.REACT_APP_BUG_REPORT_FORM
export const ENABLE_EDIT_MODAL = process.env.REACT_APP_EDIT_MODAL_ENABLED
export const CLIENT_LOGGING_ENABLED = process.env.REACT_APP_CLIENT_LOGGING_ENABLED
export const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY
export const BANNER_CONFIG = {
    enabled: process.env.REACT_APP_BANNER_ENABLED,
    message: process.env.REACT_APP_BANNER_MESSAGE,
    type: process.env.REACT_APP_BANNER_TYPE,
    startDate: process.env.REACT_APP_BANNER_START_DATE,
    endDate: process.env.REACT_APP_BANNER_END_DATE
};
export const BANNER_ADMIN_CONFIG = {
    enabled: process.env.REACT_APP_ADMIN_BANNER_ENABLED,
    message: process.env.REACT_APP_ADMIN_BANNER_MESSAGE,
    type: process.env.REACT_APP_ADMIN_BANNER_TYPE,
    startDate: process.env.REACT_APP_ADMIN_BANNER_START_DATE,
    endDate: process.env.REACT_APP_ADMIN_BANNER_END_DATE
};
export const BANNER_DRIVER_CONFIG = {
    enabled: process.env.REACT_APP_DRIVER_BANNER_ENABLED,
    message: process.env.REACT_APP_DRIVER_BANNER_MESSAGE,
    type: process.env.REACT_APP_DRIVER_BANNER_TYPE,
    startDate: process.env.REACT_APP_DRIVER_BANNER_START_DATE,
    endDate: process.env.REACT_APP_DRIVER_BANNER_END_DATE
};
export const BANNER_CUSTOMER_CONFIG = {
    enabled: process.env.REACT_APP_CUSTOMER_BANNER_ENABLED,
    message: process.env.REACT_APP_CUSTOMER_BANNER_MESSAGE,
    type: process.env.REACT_APP_CUSTOMER_BANNER_TYPE,
    startDate: process.env.REACT_APP_CUSTOMER_BANNER_START_DATE,
    endDate: process.env.REACT_APP_CUSTOMER_BANNER_END_DATE
};